import { Installation } from "@shared/types";

import { mapByField } from "@client-shared/lib/map";
import {
  DeleteInstallationAction,
  InstallationsActions,
  InstallationsState,
  PutInstallationAction,
  ResetInstallationsAction,
  SetInitializedAction,
  SetInstallationsAction,
  SetLoadingAction,
} from "./types";

export const initialState: InstallationsState = {
  initialized: false,
  loading: false,
  installations: undefined,
  error: undefined,
};

export function setLoading(loading: boolean): SetLoadingAction {
  return {
    type: "SET_LOADING",
    payload: { loading },
  };
}

export function setInitialized(initialized: boolean): SetInitializedAction {
  return {
    type: "SET_INITIALIZED",
    payload: {
      initialized,
    },
  };
}

export function setInstallations(installations: Installation[]): SetInstallationsAction {
  return {
    type: "SET_INSTALLATIONS",
    payload: { installations },
  };
}

export function putInstallation(installation: Installation): PutInstallationAction {
  return {
    type: "PUT_INSTALLATION",
    payload: { installation },
  };
}

export function deleteInstallation(installation: Installation): DeleteInstallationAction {
  return {
    type: "DELETE_INSTALLATION",
    payload: { installation },
  };
}

export function setError(error: Error | undefined): InstallationsActions {
  return {
    type: "SET_ERROR",
    payload: { error },
  };
}

export function resetInstallations(): ResetInstallationsAction {
  return {
    type: "RESET_INSTALLATIONS",
  };
}

export function reducer(state: InstallationsState, action: InstallationsActions): InstallationsState {
  switch (action.type) {
    case "SET_INITIALIZED":
      return { ...state, initialized: true };
    case "SET_LOADING":
      return { ...state, loading: action.payload.loading };
    case "SET_INSTALLATIONS":
      return { ...state, installations: mapByField("id", action.payload.installations) };
    case "PUT_INSTALLATION":
      return { ...state, installations: handlePutInstallation(action.payload.installation, state) };
    case "DELETE_INSTALLATION":
      return { ...state, installations: handleDeleteInstallation(action.payload.installation, state) };
    case "SET_ERROR":
      return { ...state, error: action.payload.error };
    case "RESET_INSTALLATIONS":
      return { ...initialState, initialized: true };
    default:
      return state;
  }
}

const handleDeleteInstallation = (installation: Installation, state: InstallationsState) => {
  const tempInstallation = new Map(state.installations);
  tempInstallation.delete(installation.id);
  return tempInstallation;
};

const handlePutInstallation = (installation: Installation, state: InstallationsState) => {
  if (!state.installations) {
    return mapByField("id", [installation]);
  }
  const newInstallations = new Map(state.installations);
  newInstallations.set(installation.id, installation);
  return newInstallations;
};
